import React from 'react';
import { Image, Pressable, StyleSheet, Text, View } from 'react-native';
import { color_333333, color_666666, white } from "../../assets/style/colors";

interface CListItemSimpleProps {
    leftText: string;
    rightText?: string;
    rightArrow?: boolean;
    handleClick?: () => void;
}

export const CListItemSimple = (item: CListItemSimpleProps) => {
    const { leftText, rightText, rightArrow, handleClick } = item;

    const handleOnPress = () => {
        // console.log('点击组件');
        handleClick && handleClick();
    };

    return (
        <Pressable onPress={handleOnPress}>
            <View style={[styles.container, styles.dflex]}>
                <Text style={styles.leftText}>{leftText}</Text>
                {typeof rightText === 'object' ? (
                    <View style={styles.rightWrap}>{rightText}</View>
                ) : (
                    <Text
                        style={styles.rightText}
                        numberOfLines={2}
                        ellipsizeMode={'tail'}>
                        {rightText}
                    </Text>
                )}

                {rightArrow && (
                    <Image
                        source={require('../../assets/image/icon_right_arrow.png')}
                        style={{ width: 18, height: 18, objectFit: 'contain' }}
                    />
                )}
            </View>
        </Pressable>
    );
};

const styles = StyleSheet.create({
    container: {
        paddingTop: 16,
        paddingBottom: 16,
        paddingRight: 15,
        paddingLeft: 15,
        borderColor: white,
        borderBottomWidth: 1,
        borderBottomColor: '#F1F1F4',
        backgroundColor: white,
    },
    leftText: {
        fontSize: 16,
        color: color_333333,
        marginRight: 15,
    },
    rightText: {
        flex: 1,
        fontSize: 16,
        color: color_666666,
        textAlign: 'right',
    },
    rightWrap: {
        flex: 1,
        alignItems: 'flex-end',
    },
    dflex: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    jcbetween: {
        justifyContent: 'space-between',
    },
});
